module.exports = __webpack_public_path__ + "img/image-placeholder.7e6102cf.png";